import CONSTANTS from './constants/constantStrings'
import store from '../store'
import { isBotRefIdOrWidgetIdChanged, isTypeBOT, isEndChatTriggerValidOnConnectionUpdate } from './utils'
import Storage from '@/services/storageLib'
import { status, constantStrings } from './constants'
import { fetchAgentDeskConfig } from './liveAgent/utils/utils'
import zChat from '@/services/liveAgent/SDK/zendesk-sdk.js'
import agentDeskProperties from "@/services/liveAgent/constants/agentDeskProperties"

const StorageEvent = {
    addStorageListener () {
        window.addEventListener('storage', function (event) {
            if (event.key === constantStrings.CONNECTION_STATUS_LABEL) {
                const connection = event.newValue === status.ONLINE
                store.dispatch('updateInternetConnectionStatus', connection)
            }
            if (validateAgentDeskUponDisconnectivity(event) && isEndChatTriggerValidOnConnectionUpdate()) {
                const timerId = this.setInterval(() => {
                    if (zChat.getConnectionStatus() === agentDeskProperties.ZENDESK.CONNECTION_STATUS.CONNECTED) {
                        store.dispatch('endChat', { 
                            message: constantStrings.CHAT_ENDED, 
                            showSessionRestartGreeting: true,
                            hideEndChatGreeting: false
                        })
                        clearInterval(timerId);
                    }
                }, 500)
            }
            if  (validateGreetingsUponDisconnectivity(event)) {
                store.dispatch('triggerProActiveGreetings')
                store.dispatch('triggerCalloutBubbleGreetings')
                return
            }
            if (event.key === `${CONSTANTS.KEY_PREFIX}widgetConfig`) {
                validateSession(event.oldValue, event.newValue)
            }
        })
    }
}

function validateSession(oldValue, newValue) {
    if (oldValue && newValue) {
        try {
            const oldWidgetConfig = JSON.parse(oldValue)
            const newWidgetConfig = JSON.parse(newValue) // throws err if value not JSON parsable
            if (isBotRefIdOrWidgetIdChanged(oldWidgetConfig, newWidgetConfig)) throw new Error()
        } catch {
            store.dispatch('endChat', { message: constantStrings.SESSION_HAS_EXPIRED, showSessionRestartGreeting: false, publishEventToIoT: false, hideEndChatGreeting: true })
        }
    }
}

// On connection status change, when user comes back online from offline also proActive greetings check is present in dispatch
function validateGreetingsUponDisconnectivity (event) {
    return (event.key === constantStrings.CONNECTION_STATUS_LABEL && event.newValue === status.ONLINE && event.oldValue === status.OFFLINE && Storage.getSessionStorageData('userInteracted'))
}

// On connection status change, when user comes back online check for agentdesk connection
function validateAgentDeskUponDisconnectivity (event) {
    const agentDeskName = fetchAgentDeskConfig()?.agentDeskChannelName
    return (event.key === constantStrings.CONNECTION_STATUS_LABEL && event.newValue === status.ONLINE && event.oldValue === status.OFFLINE && !isTypeBOT() && agentDeskName && agentDeskName === constantStrings.ZENDESK)
}

export default StorageEvent
